export default class CourseDocument {
    constructor({
        id = null,
        file_name = '',
        file_path = '',
        semester_id = null,
        teacher_id = null,
        created_at = '',
        updated_at = '',
        file_size = null,
        passage_count = null,
        char_count = null,
        teacher_uco = null,
        homework_ids = [],
        is_available = false,
    }) {
        this.id = id;
        this.file_name = file_name;
        this.file_path = file_path;
        this.semester_id = semester_id;
        this.teacher_id = teacher_id;
        this.created_at = created_at;
        this.updated_at = updated_at;
        this.file_size = file_size;
        this.passage_count = passage_count;
        this.char_count = char_count;
        this.teacher_uco = teacher_uco;
        this.homework_ids = homework_ids || [];
        // Teacher-controlled student visibility (default hidden). When false, students
        // can't see/download this file and the study chatbot won't ground answers on it.
        this.is_available = is_available;
    }

    // Whether the document produced indexed passages (and is therefore usable by the
    // RAG chat). A 0-passage doc (e.g. a scanned/image-only PDF) uploaded fine but is
    // invisible to chat -- the UI flags that so a teacher isn't misled.
    get isIndexed() {
        return (this.passage_count || 0) > 0;
    }

    // Indexing runs in a background task after upload. The backend stamps updated_at
    // when it finishes (success or empty), so: no passages yet AND no updated_at =
    // still indexing; no passages but updated_at set = finished with no text (failed).
    get isIndexing() {
        return !this.isIndexed && !this.updated_at;
    }

    // Lower-case file extension (no dot) for the type badge; '' if none.
    get fileType() {
        const name = this.file_name || '';
        const dot = name.lastIndexOf('.');
        return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
    }
}
